import React from 'react'; 
import {useEffect, useState} from 'react';
import {Box, Divider, Paper} from '@mui/material';
import {collection, getFirestore, limit, onSnapshot, orderBy, query} from 'firebase/firestore';
import {app} from '../../../../../Config/firebase.ts';
import {useAppSelector} from '../../../../../state/state.tsx';

const Inbox: React.FC = () => {
    const [campaigns, setCampaigns] = useState<any[]>([]);
    const ServiceProviderProfile = useAppSelector((state) => state.userSliceV2.data); 

    const ServiceProviderId: string = ServiceProviderProfile?.uid;

    const db = getFirestore(app);

    useEffect(() => {
        if (ServiceProviderId) {
            const CampaignCollectionReference = collection(
                db,
                'ServiceProviders',
                ServiceProviderId,
                'Campaigns'
            );

            const campaignsQuery = query(CampaignCollectionReference, orderBy('timestamp', 'desc'), limit(50));

            const unsubscribe = onSnapshot(campaignsQuery, (snapshot) => {
                const campaignsData = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setCampaigns(campaignsData);
            });

            return () => unsubscribe();
        }
    }, [ServiceProviderId]);

    return (
        <div>
            <div className={" w-full  rounded-xl bg-white p-5 shadow-[0px_0px_4px_2px_rgba(0,0,0,0.1)]"}>
                <div className={"mb-6"}>
                    <p className={"text-black text-2xl font-semibold "}>Inbox</p>
                    <p className="text-sm text-gray-600">
                        All your Past campaigns can be seen here.
                    </p></div>


                <Divider/>
                <Box sx={{maxHeight: 600, overflowY: 'auto', mt: 0}}>
                    <ul style={{listStyleType: 'none', padding: 0}}>
                        {campaigns.map((campaign) => (
                            <React.Fragment key={campaign.id}>
                                <div className={"p-4"}>
                                    <p className={"font-medium mb-2 text-sm"}>
                                        Campaign ID : <span className={"text-cc_brand"}>{"#" + campaign.id}</span>
                                    </p>
                                    <p className={"font-semibold mb-2"}>
                                        Message : {campaign.message}
                                    </p>
                                    <p className={"text-cc_secondaryText text-sm"}>
                                        Sent to {campaign.customerList.length} customers
                                        on {new Date(campaign.timestamp?.seconds * 1000).toLocaleString()}
                                    </p>
                                </div>
                                <Divider/>
                            </React.Fragment>
                        ))}
                    </ul>
                </Box>
            </div>
        </div>
    );
};

export default Inbox;
